import { Http } from '../../shared';
import { settings } from '../../settings';

export class ProductService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }

  async search(query)
  {
    try {
      var response = await this.http.get(`${this.service_url}/products?${new URLSearchParams(query)}`);
      var result = {
        data: response.data,
        page_size: response.headers['x-pagination-page-size'],
        page_number: response.headers['x-pagination-page-number'],
        total_size: response.headers['x-pagination-total-size'],
      };
      return result;
    }
    catch (ex) {
      return {
        data: []
      }
    }
    
  }
}
